(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["share-buttons"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-share-copy]').forEach((button) => {
    let timeoutId;

    button.addEventListener('click', () => {
      navigator.clipboard.writeText(button.dataset.url).then(() => {
        const status = button.closest('.share-buttons').querySelector('[data-share-status]');
        status.textContent = status.dataset.successText;
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
          status.textContent = '';
        }, 4000);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
